<template>
<!-- 后台管理 -->
    <div class="all">
            <!-- @open="true"
    @close="handleClose" -->
        <div class="navigation">
            <el-menu :default-active="this.$store.state.adminCurrentRouter" router class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
                <el-menu-item index="/admin/downloadCenter">
                    <span slot="title">下载中心</span>
                </el-menu-item>
                <el-menu-item index="/admin/companyInfo">
                    <span slot="title">企业信息</span>
                </el-menu-item>
                <el-menu-item index="/admin/developmentHistory">
                    <span slot="title">发展历程</span>
                </el-menu-item>
                <el-menu-item index="/admin/commonProblem">
                    <span slot="title">常见问题信息</span>
                </el-menu-item>
                <el-menu-item index="/admin/recruitInfo">
                    <span slot="title">招聘信息</span>
                </el-menu-item>
                <el-menu-item index="/admin/newsInfo">
                    <span slot="title">新闻动态信息</span>
                </el-menu-item>
                <el-menu-item index="/admin/jobWantedInfo">
                    <span slot="title">求职者信息</span>
                </el-menu-item>
                <el-menu-item index="/admin/contactUs">
                    <span slot="title">用户留言信息</span>
                </el-menu-item>
                <el-menu-item index="/admin/carouselChart">
                    <span slot="title">轮播图信息</span>
                </el-menu-item>
            </el-menu> 
        </div>
        <div class="topnavContent">
            <div class="topNav">
                <div></div>
                <div>
                    <a @click="cancel">注销</a>
                </div>
            </div>
            <div class="content">
                <router-view />
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'YinshiOffcialwebsiteCommonProblem',

    data() {
        return {
            
        };
    },

    mounted() {
            
    },

    methods: {
        cancel(){
            localStorage.removeItem('token');
            this.$router.push("/login");

        }
    },    
    created(){
        this.$store.state.adminCurrentRouter = this.$route.path  //获取当前页面路由
    }
};
</script>
<style lang="scss" >
    .navigation{
        .el-menu-item{
            padding-left: 20px !important;
        }
    }
</style>
<style lang="scss" scoped>

.all{
    background: #f0f2f5;
    display: flex;
}
// 左侧导航栏
.navigation{
    width: 200px;
    .el-menu-vertical-demo{
        padding-top: 20px;
        height: 100%;
    }
}
// 顶部和内容
.topnavContent{
    flex-shrink: 0;
    width: 90%;
    height: 100vh;

}
// 顶部
.topNav{
    height: 6%;
    padding:0px 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    a{
        color:blue;
        cursor: pointer;
    }
}
// 内容
.content{
    width: 96%;
    height: 86.5%;
    background: #fff;
    margin: 1%;
    padding:20px;
    overflow-x:hidden;

}
</style>